import {
    DELETEDEALERAGENT_SUCCESS,
    DELETEDEALERAGENT_FAILED,
    RESET_DELETEDEALERAGENT,
    LOADING_DELETEDEALERAGENT,
    NETWORK_ERROR_DELETEDEALERAGENT
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DELETEDEALERAGENT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DELETEDEALERAGENT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DELETEDEALERAGENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DELETEDEALERAGENT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DELETEDEALERAGENT:
            return (state = initialState);
        default:
            return state;
    }
};